// extracted by extract-css-chunks-webpack-plugin
module.exports = {"disconnected":"disconnected___1Sm_J","icon":"icon___wotBZ"};